module.exports = __webpack_public_path__ + "static/img/location_map.68bff00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/location_map.png
// module id = wHw0
// module chunks = 1